import { render, staticRenderFns } from "./a.vue?vue&type=template&id=321ef074&scoped=true"
import script from "./a.vue?vue&type=script&lang=js"
export * from "./a.vue?vue&type=script&lang=js"
import style0 from "./a.vue?vue&type=style&index=0&id=321ef074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321ef074",
  null
  
)

export default component.exports